import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_ORG_MODULES } from '../queries/orgModules';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const findOrgModules = async (orgId) => {
  try {
    const graphQlClient = await getGraphQlClient();
    const response = await graphQlClient.query({
      variables: { orgId },
      query: FETCH_ORG_MODULES,
    });
    return unmarshalGraphqlResponse(response.data, 'org_modules').edges;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
